"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.compute = exports.makeScalar = exports.scale = exports.sum = exports.make = exports.NUTRITIONAL_INFO_NONE = exports.NutritionalInfo = exports.Micronutrients = exports.Micronutrient = exports.Vitamin = exports.Cholesterol = exports.Caffeine = exports.Sodium = exports.Macronutrients = exports.Fda = exports.Rdi = void 0;
const effect_1 = require("effect");
const Energy = __importStar(require("../unit/energy"));
const Mass = __importStar(require("../unit/mass"));
const Volume = __importStar(require("../unit/volume"));
exports.Rdi = __importStar(require("./rdi"));
exports.Fda = __importStar(require("./fda"));
const NAMESPACE = 'Nutrition';
exports.Macronutrients = effect_1.Schema.Struct({
    protein: effect_1.Schema.propertySignature(Mass.Gram).annotations({
        description: 'The mass of protein (g) per 100g of the original (non-prepared) product',
    }),
    carbohydrate: effect_1.Schema.propertySignature(effect_1.Schema.Record({ key: effect_1.Schema.Literal('total', 'sugar', 'fiber'), value: Mass.Gram }).pipe(effect_1.Schema.filter(({ sugar, total }) => sugar.amount <= total.amount || {
        path: ['sugar', 'amount'],
        message: 'must be less than or equal to total carbohydrate',
    }, { jsonSchema: {} }), effect_1.Schema.filter(({ fiber, total }) => fiber.amount <= total.amount || {
        path: ['fiber', 'amount'],
        message: 'must be less than or equal to total carbohydrate',
    }, { jsonSchema: {} }), effect_1.Schema.filter(({ fiber, sugar, total }) => fiber.amount + sugar.amount <= total.amount || {
        path: ['total', 'amount'],
        message: 'must be greater than or equal to the sum of fiber and sugar carbohydrates',
    }, { jsonSchema: {} }))).annotations({
        description: 'A Record associating a carbohydrate type to its mass (g) per 100g of the original (non-prepared) product',
    }),
    fat: effect_1.Schema.propertySignature(effect_1.Schema.Record({ key: effect_1.Schema.Literal('total', 'saturated', 'unsaturated'), value: Mass.Gram }).pipe(effect_1.Schema.filter(({ saturated, total }) => saturated.amount <= total.amount || {
        path: ['saturated', 'amount'],
        message: 'must be less than or equal to total fat',
    }, { jsonSchema: {} }), effect_1.Schema.filter(({ unsaturated, total }) => unsaturated.amount <= total.amount || {
        path: ['unsaturated', 'amount'],
        message: 'must be less than or equal to total fat',
    }, { jsonSchema: {} }), effect_1.Schema.filter(({ saturated, unsaturated, total }) => saturated.amount + unsaturated.amount <= total.amount || {
        path: ['total', 'amount'],
        message: 'must be greater than or equal to the sum of saturated and unsaturated fat',
    }, { jsonSchema: {} }))).annotations({
        description: 'A Record associating a fat type to its mass (g) per 100g of the original (non-prepared) product',
    }),
}).annotations({
    identifier: `${NAMESPACE}.Macronutrients`,
    description: 'A Struct describing the protein, carbohydrate and fat content per 100g of the original (non-prepared) product',
});
const makeMicronutrient = (name) => effect_1.Schema.TaggedStruct(name, { mass: Mass.Milligram }).annotations({
    identifier: `${NAMESPACE}.Micronutrient`,
});
exports.Sodium = makeMicronutrient('Sodium').annotations({
    identifier: `${NAMESPACE}.Sodium`,
});
exports.Caffeine = makeMicronutrient('Caffeine').annotations({
    identifier: `${NAMESPACE}.Caffeine`,
});
exports.Cholesterol = makeMicronutrient('Cholesterol').annotations({
    identifier: `${NAMESPACE}.Cholesterol`,
});
exports.Vitamin = effect_1.Schema.Literal('A', 'B6', 'B12', 'C', // Fun fact: Vitamin C is also known as ascorbic acid!
'D', 'E', 'K').annotations({
    identifier: `${NAMESPACE}.Vitamin`,
});
exports.Micronutrient = effect_1.Schema.Literal(
/**Let's try to keep this in alphabetic order */
'biotin', 'calcium', 'caffeine', 'chloride', 'choline', 'cholesterol', 'chromium', 'copper', 'fluoride', 'folicAcid', 'iodine', 'iron', 'magnesium', 'manganese', 'molybdenum', 'niacin', 'pantothenicAcid', 'phosphorus', 'potassium', 'riboflavin', 'salt', 'selenium', 'sodium', 'thiamin', ...exports.Vitamin.literals.map(vitamin => `vitamin${vitamin}`), 'zinc').annotations({ identifier: `${NAMESPACE}.Micronutrient` });
const OptionalMilligram = effect_1.Schema.optionalWith(Mass.Milligram, {
    exact: true,
    default: () => Mass.Milligram.make({ amount: 0 }),
}).annotations({
    default: Mass.Milligram.make({ amount: 0 }),
});
exports.Micronutrients = effect_1.Schema.Struct(effect_1.Record.fromIterableWith(exports.Micronutrient.literals, micronutrient => [
    micronutrient,
    OptionalMilligram,
])).annotations({
    identifier: `${NAMESPACE}.Micronutrients`,
    description: `A Struct describing each micronutrients' mass (mg) per 100g of the original (non-prepared) product`,
});
exports.NutritionalInfo = effect_1.Schema.Struct({
    energy: effect_1.Schema.propertySignature(Energy.Energy).annotations({
        description: 'The energy per 100g of the original (non-prepared) product',
    }),
    macro: exports.Macronutrients,
    micro: exports.Micronutrients,
}).annotations({
    identifier: `${NAMESPACE}.NutritionalInfo`,
    description: 'A Struct describing the nutritional info per 100g of the original (non-prepared) product',
});
exports.NUTRITIONAL_INFO_NONE = {
    energy: Energy.Calorie.make({ amount: 0 }),
    macro: {
        protein: Mass.Gram.make({ amount: 0 }),
        carbohydrate: {
            sugar: Mass.Gram.make({ amount: 0 }),
            fiber: Mass.Gram.make({ amount: 0 }),
            total: Mass.Gram.make({ amount: 0 }),
        },
        fat: {
            saturated: Mass.Gram.make({ amount: 0 }),
            unsaturated: Mass.Gram.make({ amount: 0 }),
            total: Mass.Gram.make({ amount: 0 }),
        },
    },
    micro: effect_1.Record.fromIterableWith(exports.Micronutrient.literals, micronutrient => [
        micronutrient,
        Mass.Milligram.make({ amount: 0 }),
    ]),
};
/**
 * Utility function for creating a {@link NutritionalInfo} object from a deeply partial {@link NutritionalInfo}.
 *
 * Mass may be expressed as non-milligram units in `micro` properties, and will automatically be converted to milligrams.
 *
 * All deeply omitted properties will be assumed to be `0`.
 */
const make = ({ energy, macro = {}, micro = {}, }) => exports.NutritionalInfo.make({
    energy: energy ?? exports.NUTRITIONAL_INFO_NONE.energy,
    macro: {
        protein: macro.protein ?? exports.NUTRITIONAL_INFO_NONE.macro.protein,
        carbohydrate: { ...exports.NUTRITIONAL_INFO_NONE.macro.carbohydrate, ...macro.carbohydrate },
        fat: { ...exports.NUTRITIONAL_INFO_NONE.macro.fat, ...macro.fat },
    },
    micro: (0, effect_1.pipe)({ ...exports.NUTRITIONAL_INFO_NONE.micro, ...micro }, effect_1.Record.map(Mass.convert('Milligram'))),
});
exports.make = make;
/**
 * Sums all provided {@link NutritionalInfo} parameters.
 * The 0th parameter determines the units of measure of the returned {@link NutritionalInfo}.
 *
 * If no parameters are provided, {@link NUTRITIONAL_INFO_NONE} is returned.
 *
 * If a single parameter is provided, it is returned as-is.
 */
const sum = (...args) => effect_1.Array.reduce(args.slice(1), // return 0th element as-is if args only contains a single element
args[0] ?? exports.NUTRITIONAL_INFO_NONE, // return NUTRITIONAL_INFO_NONE if args is empty
(acc, { energy, macro: { protein, carbohydrate, fat }, micro }) => ({
    energy: Energy.sum(acc.energy, energy),
    macro: {
        protein: Mass.sum(acc.macro.protein, protein),
        carbohydrate: effect_1.Record.map(acc.macro.carbohydrate, (g, key) => Mass.sum(g, carbohydrate[key])),
        fat: effect_1.Record.map(acc.macro.fat, (g, key) => Mass.sum(g, fat[key])),
    },
    micro: effect_1.Record.map(acc.micro, (mg, key) => Mass.sum(mg, micro[key])),
}));
exports.sum = sum;
/**
 * Multiplies all quantities within a given {@link NutritionalInfo} object by the given scalar.
 *
 * If a scalar of `1` is provided, the provided `nutritionalInfo` is returned as-is.
 *
 * If you need to convert arbitrary supplier-specified nutritional info into domain-compliant
 * nutritional info, use {@link makeScalar} to calculate the correct scalar.
 */
const scale = (nutritionalInfo, scalar) => {
    if (scalar === 1)
        return nutritionalInfo;
    const { energy, macro: { carbohydrate, fat, protein }, micro, } = nutritionalInfo;
    return {
        energy: { _tag: energy._tag, amount: energy.amount * scalar },
        macro: {
            carbohydrate: effect_1.Record.map(carbohydrate, ({ amount }) => Mass.Gram.make({ amount: amount * scalar })),
            fat: effect_1.Record.map(fat, ({ amount }) => Mass.Gram.make({ amount: amount * scalar })),
            protein: Mass.Gram.make({ amount: protein.amount * scalar }),
        },
        micro: effect_1.Record.map(micro, ({ amount }) => Mass.Milligram.make({ amount: amount * scalar })),
    };
};
exports.scale = scale;
/**
 * Suppliers tend to provide their {@link NutritionalInfo} per arbitrary serving size at a given {@link NominalMixRatio}.
 * However, the {@link NutritionalInfo} schema is intended to represent nutritional information for 100 mL of undiluted concentrate.
 *
 * This function calculates a scalar that can be used to scale a supplier's nutritional information
 * to domain-scaled nutritional information.
 *
 * @param referenceServingSize The size of a single serving of prepared product as specified by the supplier
 * @param referenceMixRatio The recommended mixing ratio of the concentrate as specified by the supplier
 * @returns a scalar that can be provided to the {@link scale} function to scale the supplier nutritional info into domain-scaled nutritional info
 */
const makeScalar = (referenceServingSize, referenceMixRatio) => (0, effect_1.pipe)(referenceServingSize, Volume.convert('Milliliter'), ({ amount }) => amount / referenceMixRatio, // Volume of concentrate per referenceVolume
// Volume of concentrate per referenceVolume
volume => 100 / volume);
exports.makeScalar = makeScalar;
/**
 * Computes the aggregated {@link NutritionalInfo} for a drink containing one or multiple enhancements,
 * accounting for the enhancement's nominal mix ratio, actual mix ratio,
 * and the {@link Volume.Volume Volume} of the body of water these enhancements are dissolved within.
 *
 * @param enhancements An array of enhancement descriptors
 * @param volume The {@link Volume} of the body of water that the enhancements are dissolved in
 * @returns The aggregated {@link NutritionalInfo} for this drink
 */
const compute = (enhancements, volume) => (0, exports.sum)(...enhancements.map(({ nutritionalInfo, nominalMixRatio, mixRatioScalar }) => {
    const perMilliliter = (0, exports.scale)(nutritionalInfo, 1 / 100);
    const mixRatio = nominalMixRatio / mixRatioScalar;
    const enhancementVolume = Volume.convert(volume, 'Milliliter').amount / mixRatio;
    return (0, exports.scale)(perMilliliter, enhancementVolume);
}));
exports.compute = compute;
//# sourceMappingURL=index.js.map